<div class="modal_container" [class.fixed-model]="isBookingPolicy">
    <div class="modal_header">
      <p class="title" *ngIf="!isBookingPolicy"> Policy </p>
      <p class="title" *ngIf="isBookingPolicy"> Booking Policy </p>
      <a (click)="onClickClose()"><i class="fa fa-close"></i></a>
    </div>
  
    <div class="description" *ngIf="!isBookingPolicy">
    <h4 *ngIf="cancellationPolicies">Cancellation Policies</h4>
    <div *ngFor="let policy of cancellationPolicies">
      <h5>{{policy.text}}</h5>
      <div class="header">
        <p class="headers">From :</p>
        <p class="headers">To :</p>
        <p class="headers">Penalty : </p>
      </div>
      <div class="rules" *ngFor="let rule of policy.rules">
        <p class="start">{{rule.startDate}}</p>
        <p class="end">{{rule.endDate}}</p>
        <p class="value" *ngIf="rule.valueType === 'Amount'">{{rule.estimatedValue? (rule.estimatedValue |
          vtechCurrency): 'Free'}}</p>
        <p class="value" *ngIf="rule.valueType === 'Nights'">{{rule.value? (rule.value + ' ' + rule.valueType + '(          approx.' + (rule.estimatedValue | vtechCurrency) + ' )'): 'Free'}}</p>
        <p class="value" *ngIf="rule.valueType === 'Percentage'">
          <ng-container *ngIf="cancellationFlag && rule.value === 100; else checkCancellationFlag">
            Changes or cancellation made after the given date are subject to a property fee equal to 100% of the total amount
            paid for the reservation.
          </ng-container>
          <ng-template #checkCancellationFlag>
            <ng-container *ngIf="!cancellationFlag && rule.value === 100; else notFullyRefundable">
              This rate is not refundable. If you change or cancel your booking you will not get a refund.
            </ng-container>
            <ng-template #notFullyRefundable>
              <ng-container *ngIf="rule.value === 0; else partiallyRefundable">
                Fully Refundable before the given date.
              </ng-container>
              <ng-template #partiallyRefundable>
                This rate is partially refundable ({{rule.value}} {{rule.valueType}}) (approx. {{rule.estimatedValue |
                vtechCurrency}}).
              </ng-template>
            </ng-template>
          </ng-template>
        </p>
      </div>
    </div>
      <p *ngIf="policies?.length" class="title"> Hotel Policies </p>
      <div class="modal_body">
        <div *ngFor="let policy of policies">
          <p [innerHTML]="policy.text" ></p>
        </div>
      </div>
      <ng-container *ngIf="generalPolicies">
        <div *ngFor="let policys of generalPolicies">
            <h3>{{policys.type}}</h3>
            <p>{{policys.text}}</p>
            <br>
          </div>
     </ng-container>  
    
      <br>
      <p *ngIf="includes?.length" class="title"> Includes </p>
      <div class="modal_body">
        <p *ngFor="let policy of includes">
          {{policy}}
        </p>
      </div>
      <br />
      <p *ngIf="excludes?.length" class="title"> Excludes </p>
      <div class="modal_body">
        <p *ngFor="let policy of excludes">
          {{policy.displayText}}
        </p>
      </div>
      <br />
    </div>
  
    <div class="description booking-policy" *ngIf="isBookingPolicy">
      <div class="modal_body" [innerHtml]="policyHtml">
      </div>
    </div>
  
  </div>
